/**
 * The legacy /api/obd/dialer and /api/obd/dialer/update endpoints expect the
 * `groupRows` field to be a JSON-stringified `{ groupsList: [...] }` object —
 * not a bare array.
 */
export function buildGroupRowsPayload(
  groupIds: string[],
  options: Array<{ value: string; label: string }>,
): string {
  return JSON.stringify({
    groupsList: groupIds.map((id) => ({
      groupId: id,
      groupName: options.find((o) => o.value === id)?.label ?? '',
    })),
  });
}
